"use strict";

require("./modals/catalog-information.modal.js");
require("./vendor-list.service.js");

angular.module("customer")
.directive("vendorsList", function() {
    return {
        scope: false,
        templateUrl: require("./vendor-list.directive.html"),
        css: [require("./vendor-list.useable.scss")],
        controller: VendorsListController,
        controllerAs: "vendorsListCtrl"
    }
});

function VendorsListController(
    $scope, $rootScope, $stateParams, $state, VendorsListService, Language, PartnershipService, ModalService, common,
    UserService, REFRESH_HOME_VENDOR_LISTING_MESSAGE_NAME, FlashBag, PRODUCT_ACQUISITION_METHOD
) {
    var _this = this;
    Language.initializeScope($scope, "language", "locale");
    $scope.scrollFetching = false;
    $scope.scrollDisabled = false;
    $scope.displayNoVendorMessage = true;
    $scope.displayNoVendorMessageForIncompleteProfile = false;
    $scope.displayRequestedPartnershipMessageForIncompleteProfile = false;
    $scope.pagination = {};
    $scope.categories = $stateParams.categories;
    $scope.PRODUCT_ACQUISITION_METHOD = PRODUCT_ACQUISITION_METHOD;

    function updateWarning(user) {
        if (user && user.has_profile_completed) {
            $scope.displayNoVendorMessageForIncompleteProfile = !user.has_profile_completed["customer"];
            $scope.displayRequestedPartnershipMessageForIncompleteProfile = !user.has_profile_completed["all"];
            $scope.notApprovedCorporateGroupId = user.not_approved_corporate_group_id;
        }
    }

    UserService.isUserFetched().then(function onSuccess(user) {
        updateWarning(user);
    });

    $scope.$on("UserUpdated", function(event, user) {
        updateWarning(user);
    });

    this.getMoreVendors = function() {
        if (typeof $scope.pagination.num_pages === "undefined") {
            this.fetchVendors();
        }
        else if ($scope.pagination.current_page === $scope.pagination.num_pages || $scope.pagination.num_pages === 1) {
            $scope.scrollDisabled = true;
        }
        else if ($scope.pagination.num_pages > 1) {
            $scope.pagination.current_page++;
            this.fetchVendors();
        }
        else {
            $scope.scrollDisabled = true;
        }
    };

    this.fetchVendors = function() {
        $scope.scrollFetching = true;
        VendorsListService.queryVendors($scope.pagination.current_page).$promise.then(function(data) {
            $scope.pagination = data.pagination;
            if (typeof $scope.Vendors == "undefined")
                $scope.Vendors = [];
            $scope.Vendors = $scope.Vendors.concat(data.results);
            $scope.scrollFetching = false;
        }, function() {
            $scope.scrollDisabled = true;
        }).finally(function() {
            $scope.displayNoVendorMessage = true;
        });
    };

    this.refreshVendors = function() {
        $scope.Vendors = [];
        $scope.pagination.current_page = 1;
        $scope.displayNoVendorMessage = false;
        this.fetchVendors();
    };

    var unregisterRefreshHomeVendorsListing = $scope.$on(REFRESH_HOME_VENDOR_LISTING_MESSAGE_NAME, function() {
        _this.refreshVendors();
    });

    $scope.$on("$destroy", function() {
        unregisterRefreshHomeVendorsListing();
    });

    this.expandVendor = function(vendor) {
        if (vendor.is_accessible) {
            if (vendor.catalog_count === 1) {
                $state.go("stocks", {
                    vendorId: vendor.id,
                    catalog: vendor.catalog.id,
                    search: null,
                    categories: $scope.categories
                });
            }
            else {
                if (!vendor.catalogs) {
                    vendor.expanded = false;
                    VendorsListService.queryVendorCatalogs(vendor.id).$promise.then(function(data) {
                        vendor.catalogs = data;
                    });
                }
                vendor.expanded = !vendor.expanded;
            }
        }
    };

    this.requestPartnership = function(event, vendor) {
        event.currentTarget.disabled = true;
        PartnershipService.add({"vendorInvite": vendor.token_invite}).then(
            function success(data) {
                vendor.request_status = 'requested';
                FlashBag.success(data.detail, true);
            },
            function failed(response) {
                event.currentTarget.disabled = false;
                FlashBag.apiError(response, true);
            }
        );
    };

    this.openCatalogInfo = function(event, catalog) {
        event.stopPropagation();
        ModalService.showModal({
            templateUrl: require("./modals/catalog-information.modal.html"),
            controller: "CatalogInformationController",
            controllerAs: "catalogInformationCtrl",
            inputs: {
                $attrs: {
                    catalog: catalog
                }
            }
        }).then(function(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
        });
    };

}



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/vendors-list/vendor-list.directive.js
// module id = 813
// module chunks = 0